module.exports = __webpack_public_path__ + "img/favicon-text-reverse.8790671c.png";